"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _formik = require("formik");

var _InputHeader = _interopRequireDefault(require("../InputHeader"));

var _styled = require("../styled");

var _userflow = _interopRequireDefault(require("../../../../styles/userflow"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var customComponents = {
  ClearIndicator: function ClearIndicator() {
    return null;
  },
  IndicatorSeparator: function IndicatorSeparator() {
    return null;
  }
};
var styles = {
  control: function control(provided, state) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      height: '100%',
      boxShadow: 'none',
      border: "1px solid ".concat(_userflow["default"].colors.whiteLight),
      ':hover': {
        borderColor: _userflow["default"].colors.whiteLight
      }
    }, state.isFocused ? {
      outline: "1px solid ".concat(_userflow["default"].colors.blue),
      position: 'absolute',
      zIndex: 9999,
      borderRadius: '4px',
      width: '100%'
    } : {});
  },
  container: function container(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      height: '48px'
    });
  }
};

var Select = function Select(props) {
  var name = props.name,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$selectProps = props.selectProps,
      selectProps = _props$selectProps === void 0 ? {} : _props$selectProps,
      _props$header = props.header,
      header = _props$header === void 0 ? '' : _props$header,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
      prependIcon = props.prependIcon;

  var _useField = (0, _formik.useField)(name),
      _useField2 = (0, _slicedToArray2["default"])(_useField, 1),
      field = _useField2[0];

  var onBlur = field.onBlur;

  var _useFormikContext = (0, _formik.useFormikContext)(),
      setFieldValue = _useFormikContext.setFieldValue;

  return /*#__PURE__*/_react["default"].createElement(_styled.StyledInputContainer, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_InputHeader["default"], {
    text: header,
    prependIcon: prependIcon
  }), /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], (0, _extends2["default"])({
    components: customComponents,
    styles: styles,
    placeholder: placeholder,
    formatOptionLabel: function formatOptionLabel(opt) {
      return opt.value;
    }
  }, selectProps, {
    onChange: function onChange(option) {
      return setFieldValue(name, option);
    },
    onBlur: onBlur
  })));
};

var _default = Select;
exports["default"] = _default;